import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import React, { memo } from 'react';
import Button from '../Button';
import css from './SortsMobile.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

var SortsMobile = function SortsMobile(_ref) {
  var on = _ref.on,
      sorts = _ref.sorts,
      sortSelect = _ref.sortSelect;
  return /*#__PURE__*/_jsx("ul", {
    className: cc([css.list, _defineProperty({}, css.on, on)]),
    children: sorts.map(function (sort) {
      return /*#__PURE__*/_jsx("li", {
        className: css.item,
        children: /*#__PURE__*/_jsx(Button, {
          "aria-label": "Sort by ".concat(sort.label.toLowerCase()),
          linkStyle: true,
          onClick: function onClick() {
            sortSelect(sort);
          },
          children: sort.label
        })
      }, sort.label);
    })
  });
};

SortsMobile.propTypes = {
  on: PropTypes.bool.isRequired,
  sorts: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string
  })).isRequired,
  sortSelect: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(SortsMobile);